/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDAuMzUwMDA2SDEwLjgxTDE1IDQuNTQwMDFWMTUuNjVIMVYwLjM1MDAwNlpNMiAxLjM1MDAxVjE0LjY1SDE0VjUuMjUwMDFIMTAuMVYxLjM1MDAxSDJaTTcuODUgNC4yNTAwMUg0LjI1VjUuMjUwMDFINy44NVY0LjI1MDAxWk00LjI1IDcuNTAwMDFIMTEuNzVWOC41MDAwMUg0LjI1VjcuNTAwMDFaTTExLjc1IDEwLjc1SDQuMjVWMTEuNzVIMTEuNzVWMTAuNzVaIiBmaWxsPSJpbmhlcml0Ii8+";